<template>
  <section class="landing-page-questions">
    <div class="landing-page__container">
      <div class="landing-page-questions__content">
        <h2 class="landing-page__title landing-page__title_bold landing-page__title_colored">
          {{ $t('landingPage.contactsForm.title') }}
        </h2>
        <div class="landing-page-questions__content-description">
          {{ $t('landingPage.contactsForm.description') }}
        </div>
        <button
          class="landing-page__button landing-page-questions__button"
          @click="selectConsultation"
        >
          {{ $t('landingPage.contactsForm.buttonText') }}
        </button>
      </div>
      <transition name="fade-el">
        <requestModal
          v-if="isVisibleRequestModal"
          @closeRequestModal="closeRequestModal"
        />
      </transition>
    </div>
  </section>
</template>

<script>
import requestModal from '@/components/modals/requestModal';

export default {
  name: 'Questions',
  components: {
    requestModal,
  },
  data: () => ({
    isVisibleRequestModal: false,
  }),
  methods: {
    selectConsultation() {
      this.isVisibleRequestModal = true;
    },
    closeRequestModal() {
      this.isVisibleRequestModal = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../sass/variables";
@import "../../sass/mixins";

.landing-page-questions {
  background: url('../../assets/images/landing/questions-bg.png') no-repeat;
  background-size: cover;

  .landing-page__container {
    position: relative;

    &:after {
      content: '';
      max-width: 1220px;
      position: absolute;
      bottom: 0;
      height: 1px;
      left: 20px;
      width: 100%;
      background: $color-shark-dark;
    }
  }

  &__button {
    max-width: 303px;
    width: 100%;
    height: 58px;
    letter-spacing: .3px;
  }

  &__content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 100px 0 75px 0;

    &-description {
      font: $font-size-landing-lg $font-landing-global;
      margin-top: 8px;
      margin-bottom: 41px;
      text-align: center;
      color: $color-white;
      letter-spacing: .6px;

      @include mobile {
        font-size: $font-size-landing-sm;
        margin-top: 8px;
        margin-bottom: 31px;
        max-width: 290px;
      }
    }
  }
}

@include tablet-landscape {
  .landing-page-questions {
    .landing-page {
      &__container {
        &:after {
          left: 0;
          max-width: none;
        }
      }
    }
  }
}

@include mobile {
  .landing-page-questions {

    &__content {
      padding: 50px 0;
    }
  }
}
</style>
